import { COMPANY, NAV_LINKS } from "@/data/content";
import { ShieldCheck } from "@phosphor-icons/react";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2.5">
              <ShieldCheck weight="fill" className="h-7 w-7 text-[#F87171]" />
              <span className="font-serif-display text-2xl font-bold">Crestline Risk Management</span>
            </div>
            <p className="mt-5 text-slate-400 max-w-md leading-relaxed">{COMPANY.tagline}. Professional, ethical and result-driven collection services for financial institutions.</p>
            <p className="mt-6 font-mono-plex text-xs text-slate-500">GST: {COMPANY.gst}</p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-slate-500 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button data-testid={`footer-nav-${l.label.toLowerCase()}`} onClick={() => go(l.href)}
                    className="text-slate-300 hover:text-white transition-colors duration-200">{l.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-slate-500 mb-5">Contact</p>
            <ul className="space-y-3 text-slate-300">
              <li><a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors duration-200">{COMPANY.email}</a></li>
              {COMPANY.phones.map((p) => <li key={p}>{p}</li>)}
              <li className="text-slate-400 leading-relaxed">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</p>
          <p>{COMPANY.businessType}</p>
        </div>
      </div>
    </footer>
  );
};
